import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import CloseBtn from "assets/icons/Close.svg";
import { QrCodeDownload } from "./QrCodeDownload";
import { NavLink } from "react-router-dom";

export function QrCodeModal(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <NavLink
        className="btn btn-danger rounded-pill py-3 px-5 mr-1 float-right"
        to={"/eb/print-qr-code"}
        target="_blank"
        rel="noopener noreferrer"
      >
        Download QR Code
      </NavLink>
      <Modal
        show={show}
        onHide={handleClose}
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header className="d-block justify-content-center">
          <button type="button" className="close" onClick={handleClose}>
            <img src={CloseBtn} alt="modal-close" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <QrCodeDownload></QrCodeDownload>
        </Modal.Body>
      </Modal>
    </div>
  );
}
